import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';


//redux

import { Link, useNavigate } from "react-router-dom";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { useMutation } from '@tanstack/react-query';
import { jwtDecode } from 'jwt-decode';
import { adminChangePassword } from '../../lib/Apis';
import { toast } from "react-hot-toast";
import CustomToaster from '../../Components/Common/Toaster';



const ChangePassword = (props) => {

    // Inside your component
    const navigate = useNavigate()


    const [showPassword, setShowPassword] = useState(false);



    const [decodedToken, setDecodedToken] = useState(null);
    const [error, setError] = useState('');

    useEffect(() => {
        // Get token from sessionStorage
        const storedToken = sessionStorage.getItem('token');

        if (!storedToken) {
            setError('No token found in sessionStorage.');
            return;
        }


        try {
            const decoded = jwtDecode(storedToken);
            setDecodedToken(decoded?.id);
        } catch (err) {
            console.error('Invalid token:', err);
            setError('Invalid or malformed token.');
        }
    }, []);
   


    const {
        mutate: changePasswordMutation,
        isLoading,
        isError,
        error: passwordError,
        data: ChangePasswordData,
    } = useMutation({
        mutationFn: adminChangePassword,
        onSuccess: (data) => {
         
            toast.success(data.message, {
                onClose: () => navigate("/users"), // Navigates after toast disappears
                autoClose: 3000, // Adjust duration if needed
            });
             validation.resetForm();
        },
        onError: (err) => {
            console.error("Login error:", err.message);
        },
    });



    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            newPassword: '',
            confirmPassword: '',
        },

        validationSchema: Yup.object({
            newPassword: Yup.string()
                .min(6, 'Password must be at least 6 characters')
                .required('Please enter a new password'),

            confirmPassword: Yup.string()
                .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
                .required('Please confirm your new password'),
        }),

        onSubmit: (values) => {
            const payload = {
                id: decodedToken, // 👈 pass the ID
                password: values.newPassword,
                confirmPassword: values.confirmPassword,
            };
            changePasswordMutation(payload);
        }
    });



    const signIn = type => {

    };

    //handleTwitterLoginResponse
    // const twitterResponse = e => {}

    //for facebook and google authentication
    const socialResponse = type => {
        signIn(type);
    };




    document.title = "Basic SignIn | Velzon - React Admin & Dashboard Template";
    return (
        <React.Fragment>

            <div className="auth-page-content">
                <Container>
                    <CustomToaster />
                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <Card style={{ marginTop: '90px' }}>

                                <CardBody className="p-4">
                                    <div className="text-center mt-2">
                                        <h5 className="text-primary">Change Password !</h5>
                                        <p className="text-muted">Change Password</p>
                                    </div>
                                    {/* {error && error ? (<Alert color="danger"> {error} </Alert>) : null} */}
                                    <div className="p-2 mt-4">
                                        <Form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                            action="#">

                                            <div className="mb-3">
                                                <Label className="form-label" htmlFor="newPassword">New Password</Label>
                                                <Input
                                                    name="newPassword"
                                                    type={showPassword ? "text" : "password"}
                                                    className="form-control"
                                                    placeholder="Enter New Password"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.newPassword || ""}
                                                    invalid={
                                                        validation.touched.newPassword && validation.errors.newPassword ? true : false
                                                    }
                                                />
                                                {validation.touched.newPassword && validation.errors.newPassword && (
                                                    <FormFeedback type="invalid">{validation.errors.newPassword}</FormFeedback>
                                                )}
                                            </div>

                                            <div className="mb-3">
                                                <Label className="form-label" htmlFor="confirmPassword">Confirm Password</Label>
                                                <Input
                                                    name="confirmPassword"
                                                    type={showPassword ? "text" : "password"}
                                                    className="form-control"
                                                    placeholder="Confirm Password"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.confirmPassword || ""}
                                                    invalid={
                                                        validation.touched.confirmPassword && validation.errors.confirmPassword ? true : false
                                                    }
                                                />
                                                {validation.touched.confirmPassword && validation.errors.confirmPassword && (
                                                    <FormFeedback type="invalid">{validation.errors.confirmPassword}</FormFeedback>
                                                )}
                                            </div>
                                            {ChangePasswordData?.status && (
                                                <Alert className="border-0 alert-warning text-center mb-2 mx-2" role="alert">
                                                    {ChangePasswordData?.message}
                                                </Alert>
                                            )}


                                            {isError && (
                                                <div className="alert alert-danger mt-3">
                                                    {passwordError || "Something went wrong"}
                                                </div>
                                            )}


                                            <div className="form-check">
                                                <Input className="form-check-input" type="checkbox" value="" id="auth-remember-check" />
                                                <Label className="form-check-label" htmlFor="auth-remember-check">Remember me</Label>
                                            </div>

                                            <div className="mt-4">
                                                <Button color="success" className="btn btn-success w-100" type="submit">
                                                    {/* {loading ? <Spinner size="sm" className='me-2'> Loading... </Spinner> : null} */}
                                                    Change Password
                                                </Button>
                                            </div>

                                            <div className="mt-4 text-center">
                                                <div className="signin-other-title">
                                                    <h5 className="fs-13 mb-4 title">Sign In with</h5>
                                                </div>
                                                <div>
                                                    <Link
                                                        to="#"
                                                        className="btn btn-primary btn-icon me-1"
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            socialResponse("facebook");
                                                        }}
                                                    >
                                                        <i className="ri-facebook-fill fs-16" />
                                                    </Link>
                                                    <Link
                                                        to="#"
                                                        className="btn btn-danger btn-icon me-1"
                                                        onClick={e => {
                                                            e.preventDefault();
                                                            socialResponse("google");
                                                        }}
                                                    >
                                                        <i className="ri-google-fill fs-16" />
                                                    </Link>
                                                    <Button color="dark" className="btn-icon"><i className="ri-github-fill fs-16"></i></Button>{" "}
                                                    <Button color="info" className="btn-icon"><i className="ri-twitter-fill fs-16"></i></Button>
                                                </div>
                                            </div>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>

                            <div className="mt-4 text-center">
                                <p className="mb-0">Don't have an account ? <Link to="/register" className="fw-semibold text-primary text-decoration-underline"> Signup </Link> </p>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </div>

        </React.Fragment>
    );
};

export default ChangePassword